module.exports = __webpack_public_path__ + "img/news.98aa1267.svg";